<template>
  <div class="component">
    <img :src="getImageSrc()" class="input" alt="Placeholder Image" :style="{width: `${component.width}px`, height: `${component.height}px`}">
    <img src="@/assets/trash.png" alt="trash" class="icon-sm" v-if="showTrash" @click="deleteComponent" />
  </div>
</template>

<script>

export default {
  name: "SpacerComponent",
  props: {
    component: Object,
    interactable: Boolean,
    showTrash: Boolean,
  },
  methods: {
    deleteComponent() {
      this.$emit("deleteComponent");
    },
    checkComponentIsFilled() {
      return true;
    },
    getImageSrc() {
      if (!this.component.data) {
        return '/placeholder.png';
      }

      return this.component.data;
    }
  },
  emits: ["onUpdateValue", "deleteComponent"],
};
</script>

<style scoped>
.component {
  position: relative;
  width: 100%;
}

.input {
  max-width: 100%;
  display: flex;
  align-items: center;
  font-style: italic;
}

.label {
  vertical-align: top;
  display: inline;
  width: 100%;
  line-height: 28px;
}

.icon-sm {
  display: block;
  position: absolute;
  top: 0px;
  right: 0px;
  height: 25px;
  filter: saturate(0);
  background: #fff;
}

.icon-sm:hover {
  cursor: pointer;
  filter: none;
}

</style>